import { Routes } from 'react-router'
Routes.displayName = 'Routes'

export { Routes }
